jQuery(function ($) {
  $(document).on("mouseover", function (e) {
      let clickedElement = e.target;
      let target = $(clickedElement).data("hover-target");
      if(target) {
        if($(clickedElement).hasClass('title') || $(clickedElement).hasClass('shape') ) return false;
        $('.hover-image').css('opacity',0);
        $(clickedElement).css('opacity',1);
        $(`.shapes-collection:not(.${target})`).hide()
        $(`.shapes-collection.${target}`).show()
      }
  });

  $(document).on("mouseleave",'*', function () {
    if($(this).hasClass('title') || $(this).hasClass('shape') || $(this).hasClass('hover-image') ) return false;
    $(`.shapes-collection`).hide()
    $('.hover-image').css('opacity',0);
  });

  $('body').on('mouseover','.check-mark-tooltip',function(){
    $(this).addClass('hidden');
  })
  $('body').on('click','.check-mark-tooltip',function(){
    $(this).removeClass('hidden');
  })




  

  $('.shapes-collection:not(".battery-pedal")').fadeIn(1000); 
  $('.hover-image:not(".battery-pedal-overly")').animate({opacity: 1}, 1000);




  setTimeout(() => {
    $('.shapes-collection').fadeOut(1000);  
    $('.hover-image').animate({opacity: 0}, 1000);
  },1000)


  setTimeout(() => {
    $('.shapes-collection.battery-pedal').fadeIn(1000);  
    $('.hover-image.battery-pedal-overly').animate({opacity: 1}, 1000);
},2500)

  setTimeout(() => {
    $('.shapes-collection').fadeOut(1000);  
    $('.hover-image').animate({opacity: 0}, 1000);
  },3000)

  setTimeout(() => {
    $('.shapes-collection').css('display', 'none');  
    $('.hover-image').css('display', 'block');  
  },5000)


});
